import { SelectOption } from '@/components/form-builder/form-builder.types';
import { ActivityDto } from '@/types';
import { createStore, withProps } from '@ngneat/elf';

export interface ActivityStateProps {
  response: any;
  dto: ActivityDto;
  activityCategorySelected: SelectOption;
  isEqual: boolean;
  serverState: any;
}

export const activityInitialState: ActivityStateProps = {
  response: [],
  dto: {
    libelle: '',
    categorieActiviteId: 0,
  },
  activityCategorySelected: {
    name: '',
    code: '',
  },
  isEqual: true,
  serverState: undefined,
};

export const activityStateStore = createStore(
  { name: 'activity-state' },
  withProps<ActivityStateProps>({
    ...activityInitialState,
  })
);
